import { z } from 'zod'
import { Model } from './architecture'

export const NumberOfCommentsValidation = z.object({
  value: z.number({ required_error: '[NumberOfComments] value is required' }).min(0),
})

export class NumberOfComments extends Model {
  static create({ value }: z.infer<typeof NumberOfCommentsValidation>) {
    NumberOfCommentsValidation.parse({ value })
    return new NumberOfComments(value)
  }

  static createOrEmpty({ value }: { value?: number }) {
    return NumberOfComments.create({ value: value ?? 0 })
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
